<template>
  <v-flex class="agent-pending-invites">
    <v-card id="agentPendingInvites">
      <v-card-title class="card-title">
        Pending Invites
      </v-card-title>
      <v-divider />
      <v-flex v-if="profile.clients" class="clients-list-container">
        <v-flex v-for="(client, index) in profile.clients" :key="index">
          <v-card-title v-if="!client.lastActivity" class="clients-list">
            {{ client.name }}
            <span v-if="!getDateOfLastInvite(client)" class="status-reinvite" @click="sendReminder(client)">SEND REMINDER</span>
            <span v-else class="status-invited">SENT</span>
          </v-card-title>
        </v-flex>
      </v-flex>
    </v-card>
  </v-flex>
</template>
<script>
import { mapMutations } from 'vuex'
import { dateOfLastInvite, onSendInviteClicked } from '../../services/invite-service'
export default {
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    async sendReminder(client) {
      const updatedProfile = await onSendInviteClicked(client, this.profile)
      this.setAgentData(updatedProfile)
    },
    getDateOfLastInvite(profile) {
      return dateOfLastInvite(profile)
    }
  }
}
</script>
<style lang="sass">
.agent-pending-invites
  height: calc(85vh - 3rem - 300px)
  display: flex
  align-items: stretch
#agentPendingInvites
  flex: 1 auto
.clients-list-container
  margin-top: 3rem
  overflow: scroll !important
  height: 80%
.clients-list
  font-weight: 400 !important
  font-size: 1.4rem !important
  padding: 16px 16px !important
  display: flex
  justify-content: space-between
.status-reinvite
  color: $hwayzBrandGold !important
  font-size: 1.4rem
  cursor: pointer
.status-reinvite:hover
  color: $hwayzBrandBlue !important
.status-invited
  color: $hwayzBrandBlue !important
</style>
